import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ControlDietaEntity, ServicioControlDietaService, FiltrosControlDietaEntity, JornadasDietaEntity } from '../../../../../services/servicio-control-dieta.service';
import { FechaService } from '../../../../../services/utils/fecha.service';
import { HttpErrorResponse } from '@angular/common/http';
import { EntidadEmpresarialEntity, ServicioEntidadService } from '../../../../../services/servicio-entidad.service';

@Component({
  selector: 'app-header-control-dieta',
  templateUrl: './header-control-dieta.component.html',
  styleUrls: ['./header-control-dieta.component.css']
})
export class HeaderControlDietaComponent implements OnInit {

  loading: boolean;
  fechaInicial: string;
  fechaFinal: string;
  mensajeError: string;

  jornadasDieta: JornadasDietaEntity[];
  jornadasDietasSelected: any[];
  jornadasDietaItem: SelectItem[] = [];

  entidad: EntidadEmpresarialEntity;
  reportData: ControlDietaEntity[] = [];

  @Input() public objetoParametros: FiltrosControlDietaEntity;

  @Output() emitLoading: EventEmitter<boolean>;
  @Output() emitError: EventEmitter<string>;
  @Output() emitData: EventEmitter<{entidad: EntidadEmpresarialEntity, data: ControlDietaEntity[]}>;

  constructor( private servicioControlDieta: ServicioControlDietaService,
    private servicioFecha: FechaService,
    private servicioEntidad: ServicioEntidadService) {
      this.emitLoading = new EventEmitter();
      this.emitError = new EventEmitter();
      this.emitData = new EventEmitter();
  }

  ngOnInit() {
    this.setLoading(true);
    this.getEntidadEmpresarial();
  }

  // Carga

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioEntidad
        .getEntidadEmpresarial(this.objetoParametros.codigoBaseDatos, Number(this.objetoParametros.uncoSede));
      if (response != null) {
        response.subscribe((data: any) => {
          this.entidad = data[0];
          this.getJornadasDieta();
        }, (err: HttpErrorResponse) => {
          this.entidad = null;
          console.error('Error getEntidadEmpresarial()', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener información de la entidad, reporte caso al administrador');
        });
      }
    } catch (e) {
      this.entidad = null;
      console.error('Error Catch getEntidadEmpresarial()', e);
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener información de la entidad, reporte caso al administrador');
    }
  }

  async getJornadasDieta() {
    try {
      const response = await this.servicioControlDieta.getJornadasDieta(this.objetoParametros.codigoBaseDatos);
      if (response != null) {
        response.subscribe((data: JornadasDietaEntity[]) => {
          this.jornadasDieta = data;
          this.jornadasDietaItem = [];
          if (data && data.length > 0) {
            data.forEach((d: JornadasDietaEntity) => {
              this.jornadasDietaItem.push({ label : d.descripcion, value : d.unco});
            });
            this.jornadasDietasSelected = [];
          }
          this.setLoading(false);
        }, (err: HttpErrorResponse) => {
            console.error('getJornadasDieta()', err);
            this.setLoading(false);
            this.emitError.emit('<i class="fa fa-warning"></i> No fue posible obtener información de las jornadas de dieta');
        });
      }
    } catch (e) {
      console.error('getJornadasDieta()', e);
      this.setLoading(false);
      this.emitError.emit('<i class="fa fa-warning"></i> No fue posible obtener información de las jornadas de dieta');
    }
  }

  async getData(filtros: FiltrosControlDietaEntity) {
    try {
      const response = await this.servicioControlDieta.getControlDieta(filtros);
      if (response != null) {
        response.subscribe((data: ControlDietaEntity[]) => {
          this.reportData = data;
          this.emitData.emit({ entidad : this.entidad, data : data });
          this.setLoading(false);
        }, (err: HttpErrorResponse) => {
          this.reportData = [];
          console.error('Error getData()', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener datos del control de dieta, reporte caso al administrador');
          this.setLoading(false);
        });
      }
    } catch (e) {
      this.reportData = [];
      console.error('Error getData()', e);
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener datos del control de dieta, reporte caso al administrador');
      this.setLoading(false);
    }
  }

  // Listener
  setLoading(value: boolean) {
    this.loading = value;
    this.emitLoading.emit(value);
  }

  showMessage(error: string, life?: number) {
    this.mensajeError = error;
    const timeout = life ? life : 3500;
    setTimeout(() => {
      this.mensajeError = null;
    }, timeout);
  }

  onGenerar() {
    this.setLoading(true);
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);

    if (inicio === null || inicio.getTime() === 0) {
      this.showMessage('<i class="fa fa-warning"></i> Recuerde que debe seleccionar la <strong>Fecha Inicial</strong>');
      this.setLoading(false);
    } else if (fin === null || fin.getTime() === 0) {
      this.showMessage('<i class="fa fa-warning"></i> Recuerde que debe seleccionar la <strong>Fecha Final</strong>');
      this.setLoading(false);
    } else if (this.servicioFecha.compare(inicio, fin) === 1) {
      this.showMessage('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>');
      this.setLoading(false);
    } else if (this.jornadasDietasSelected.length === 0) {
      this.showMessage('Recuerde que debe seleccionar al menos una <strong>Jornada</strong>');
      this.setLoading(false);
    } else {
      const filtros: FiltrosControlDietaEntity = {
        uncoSede : this.objetoParametros.uncoSede,
        codigoBaseDatos : this.objetoParametros.codigoBaseDatos,
        inicio : inicio.getTime(),
        fin : fin.getTime(),
        jornadas : this.jornadasDietasSelected.toString()
      };
      this.getData(filtros);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('control-dieta-admision').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
          integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );

    popupWin.document.close();
  }

  // Auxiliares

  isDisabledImprimir() {
    return this.loading || !this.reportData || this.reportData === null || this.reportData.length === 0;
  }

}
